module.exports = require('./lib/ReactWithAddons');



//////////////////
// WEBPACK FOOTER
// ./~/react/addons.js
// module id = 173
// module chunks = 0